import "./styles.css";
import { listeners } from "./scripts/listeners.js";

listeners();